export const MAX_VARIANCE_PERIODS: Array<number> = [6, 5, 4, 3, 2, 1];
